<div class="bg-white rounded-lg p-6 shadow-sm">
  <h2 class="text-2xl font-bold mb-6">Tu pedido</h2>

  <!-- Empty State -->
  @if (productsCart.length === 0) {
    <div class="flex flex-col items-center justify-center py-8 text-gray-500">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-16 w-16 mb-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
      </svg>
      <p class="text-lg font-medium">Tu carrito está vacío</p>
      <p class="text-sm">¡Agrega productos para comenzar!</p>
    </div>
  }

  <!-- Products List -->
  @for (product of productsCart; track product) {
    <div class="border-b border-gray-200 pb-4 mb-4 last:border-b-0">
      <div class="flex items-start justify-between">
        <div class="flex items-start gap-4">
          <img [src]="product.image" [alt]="product.name" class="w-20 h-20 object-cover rounded-lg">
          <div>
            <h3 class="font-bold text-lg">{{ product.name }}</h3>
            <!-- <p class="text-gray-600 text-sm">{{ product.name_restaurant }}</p> -->
            <!-- Variations Section -->
            @if (product.variations && product.variations.length > 0) {
              <div class="mt-2">
                <p class="text-sm font-medium text-gray-700">Variaciones:</p>
                <ul class="ml-2">
                  @for (variation of product.variations; track variation) {
                    <li class="text-sm text-gray-600 flex justify-between">
                      <span>{{ variation.name }}</span>
                      @if (variation.priceAdjustment) {
                        <span class="text-gray-700">${{ variation.priceAdjustment }}</span>
                      }
                    </li>
                  }
                </ul>
              </div>
            }
            <!-- Complements Section -->
            @if (product.complements && product.complements.length > 0) {
              <div class="mt-2">
                <p class="text-sm font-medium text-gray-700">Complementos:</p>
                <ul class="ml-2">
                  @for (complement of product.complements; track complement) {
                    <li class="text-sm text-gray-600 flex justify-between">
                      <span>{{ complement.name }}</span>
                      @if (complement.priceComplement) {
                        <span class="text-gray-700">${{ complement.priceComplement }}</span>
                      }
                    </li>
                  }
                </ul>
              </div>
            }
            <!-- Quantity -->
            <div class="flex items-center mt-2">
              <span class="text-sm font-medium text-gray-700">Cantidad:</span>
              <span class="mx-2 font-medium">{{ product.quantity }}</span>
            </div>
          </div>
        </div>
        <span class="font-bold">${{ product.subtotal.toFixed(2) }}</span>
      </div>
    </div>
  }

  <!-- Total -->
  <!-- <div *ngIf="productsCart.length > 0" class="mt-6 pt-4 border-t border-gray-200">
  <div class="flex justify-between items-center font-bold text-lg">
    <span>Total:</span>
    <span>${{ totalAmount.toFixed(2) }}</span>
  </div>
</div> -->
</div>
